/**
 * Choosing a card design. Cosmetic and yours alone — two people in one game can use
 * different designs, so this never reaches the server. scope.md §9.
 *
 * Each design shows a card of every suit, since telling the suits apart is the point.
 */

import type { Suit } from '@garbage/shared';
import { PACK_LIST, type PackId } from '../packs.js';
import { useT } from '../i18n.js';
import { CardFace } from './Card.js';

const SUITS: Suit[] = ['spades', 'hearts', 'diamonds', 'clubs'];

export function PackPicker({ pack, onPack }: { pack: PackId; onPack: (pack: PackId) => void }) {
  const t = useT();
  return (
    <div className="grid grid-cols-2 gap-2" data-testid="pack-picker">
      {PACK_LIST.map((design) => (
        <button
          key={design.id}
          type="button"
          data-testid={`pack-${design.id}`}
          aria-pressed={pack === design.id}
          onClick={() => onPack(design.id)}
          className={[
            'flex flex-col items-center gap-1.5 rounded-xl px-1 py-2',
            pack === design.id ? 'bg-sun/20 ring-2 ring-sun' : 'bg-white/10',
          ].join(' ')}
        >
          <span className="flex gap-1">
            {SUITS.map((suit) => (
              <CardFace
                key={suit}
                card={{ id: `sample-${design.id}-${suit}`, rank: '7', suit }}
                size="tiny"
                pack={design.id}
              />
            ))}
          </span>
          <span className="text-xs font-bold leading-tight">{t(`pack.${design.id}.name`)}</span>
        </button>
      ))}
    </div>
  );
}
